<script lang="ts">
  import { onMount } from "svelte";
  import { initChallengesList, loading, records, section } from "./task-challenge.store";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { navigate } from "../../app.logic";
  import StarsGrade from "../../components/Business/StarsGrade.svelte";

  export let sectionId: number;

  function onChallengeClick(challengeId: number) {
    navigate(`/task/${sectionId}/${challengeId}/general`);
  }

  function backToCategories() {
    navigate(`/task`);
  }

  onMount(() => initChallengesList(sectionId));
</script>

<MainLayout>
  <nav class="breadcrumb" aria-label="breadcrumbs">
    <!-- svelte-ignore a11y-missing-attribute -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <ul>
      <li><a on:click={(_) => backToCategories()}>Categories</a></li>
      <li class="is-active"><a aria-current="page">{$section?.name || ""}</a></li>
    </ul>
  </nav>

  {#if $loading}
    <h2>loading</h2>
  {:else if $records}
    {#if $records.length == 0}
      <div class="box has-text-centered">
        <h2 class="subtitle">Currently there are no challenges in this section</h2>
      </div>
    {:else}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <!-- svelte-ignore a11y-no-static-element-interactions -->
      <div class="challenges-container">
        {#each $records as challenge}
          <div class="challenge">
            <div class="box noselect clickable" on:click={(_) => onChallengeClick(challenge.oid)}>
              <p class="title">{challenge.challenge.name}</p>

              <div class="icons">
                <div class="icon-slot">
                  <StarsGrade value={challenge.challenge.difficulty} />
                </div>
                <div class="icon-slot" style="float:right;">
                  <div class="field is-grouped is-grouped-multiline">
                    <div class="control">
                      <div class="tags has-addons">
                        <span class="tag is-dark">{challenge.maxPoints}%</span>
                        <span class="tag has-background-grey-lighter">
                          <i
                            class="material-icons icon-base"
                            class:icon-slot-todo={challenge.maxPoints == 0}
                            class:icon-slot-wip={challenge.maxPoints > 0 && challenge.maxPoints < 100}
                            class:icon-slot-done={challenge.maxPoints == 100}>done_outline</i
                          >
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        {/each}
      </div>
    {/if}
  {/if}
</MainLayout>

<style>
  .challenges-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .challenge {
    display: block;
    min-width: 30rem;
    width: 30rem;
    margin-right: 2rem;
    margin-bottom: 1rem;
    background-color: #fafafa;
  }

  .clickable {
    cursor: pointer !important;
  }

  .icon-slot {
    display: inline-block;
  }

  .icon-slot-todo {
    color: gray;
  }
  .icon-slot-wip {
    color: orange;
  }
  .icon-slot-done {
    color: green;
  }
</style>
